import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { MdCreate } from "react-icons/md";
import { TabPanelContext } from "../../../../context/ContextIndex";
import DataGridRange from "../../../../components-old/elements/DataGridRange/DataGridRange";
import GridAction from "../../../../components-old/elements/GridAction/GridAction";
import ButtonGroup from "../../../../components-old/elements/ButtonGroup/ButtonGroup";
import { Checkbox } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";
import { notifyToast, ToastType } from "../../../../components-old/ComponentsIndex";

const ReplacementProductList = ({ onAddClick, setShowForm, setIsFormValid }) => {
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();
  const { t } = useTranslation();

  const [replacementProductRecordList, setReplacementProductRecordList] = useState([]);
  const [dataGridPageSize, setDataGridPageSize] = useState(10);
  const [totalReplacementProduct, setTotalReplacementProduct] = useState(0);
  const [gridPageSizeOptions] = useState([10, 20, 50]);

  // Set replacement products after fetching or directly for non-edit cases
  const setReplacementProductList = (replacementProductList) => {
    const sortedList = [...replacementProductList].sort((a, b) => a.StartFrequencyReposition - b.StartFrequencyReposition);

    const updatedList = sortedList.map((item, index) => ({
      id: index,
      ReplaceProductId: item.ReplaceProductId,
      StartFrequencyReposition: item.StartFrequencyReposition,
      EndFrequencyReposition: item.EndFrequencyReposition,
      MaintenancePercentage: item.MaintenancePercentage,
      recordResponse: { ...item, Deleted: false },
      deleted: false,
    }));

    setReplacementProductRecordList(updatedList);
    setTotalReplacementProduct(updatedList.length);
  };

  useEffect(() => {
    const replacementProducts = _tabContext.data?.replacementProducts || [];
    if (replacementProducts.length > 0) setReplacementProductList(replacementProducts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditReplacementProductClick = (data) => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedReplacementProduct: data,
      },
    });

    setShowForm(true);
  };

  const handleDeleteReplacementProduct = (data, selectionStatus) => {
    try {
      const _gridRecord = replacementProductRecordList.map(item => {
        if (item.id === data.id) {
          return {
            ...item,
            deleted: selectionStatus,
            recordResponse: {
              ...item.recordResponse,
              Deleted: selectionStatus,
            },
          };
        }
        return item;
      });

      setReplacementProductRecordList(_gridRecord);
      _tabContextObject.setTabFormContext({
        data: {
          ..._tabContext.data,
          replacementProducts: _gridRecord,
        },
      });

      // Check if at least one record has deleted set to false
      const hasActiveRecords = _gridRecord.some(item => !item.deleted);
      if (!hasActiveRecords)
        notifyToast("Replacement product is mandatory", ToastType.ERROR);
      setIsFormValid(hasActiveRecords);

    } catch (err) {
      alert(err);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setDataGridPageSize(newPageSize);
  };

  const actionConfigs = [
    {
      icon: MdCreate,
      onClick: handleEditReplacementProductClick,
      buttonColor: "#EEEEE",
      action: "edit",
    },
  ];

  const buttonConfigs = [
    {
      buttonText: <AddIcon />,
      buttonType: "filled",
      onClick: onAddClick,
      buttonColor: "#A62B23",
      textColor: "#fff",
      action: "create",
    },
  ];

  const dataGridSchema = [
    {
      field: "StartFrequencyReposition",
      headerName: t("replacementProduct.startFrequency"),
      flex: 1,
    },
    {
      field: "EndFrequencyReposition",
      headerName: t("replacementProduct.endFrequency"),
      flex: 1,
    },
    {
      field: "MaintenancePercentage",
      headerName: t("replacementProduct.maintenancePercentage"),
      flex: 1,
    },
    !IsLoggedInUserViewer() && {
      field: "deleted",
      headerName: "Mark for Delete",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Checkbox defaultChecked={false} onChange={(e) => handleDeleteReplacementProduct(params.row, e.target.checked)} />
      ),
    },
    {
      field: "action",
      headerName: t,
      flex: 1,
      sortable: false,
      renderCell: (params) => <GridAction actionsConfig={actionConfigs} row={params.row} />,
    },
  ];

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontWeight: "bold", height: "30px" }}>{t("createReplacementProducts.listHeader")}</div>
        <ButtonGroup buttons={buttonConfigs} />
      </div>

      <DataGridRange
        rows={replacementProductRecordList}
        columns={dataGridSchema}
        pageSize={dataGridPageSize}
        pageSizeOptions={gridPageSizeOptions}
        onPageSizeChange={handlePageSizeChange}
        totalRowCount={totalReplacementProduct}
        toolbarHeader=""
        toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
      />
    </>
  );
};

export default ReplacementProductList;
